
import Vue from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Footer from '@/components/Footer/index.vue';
import Header from '@/components/Header/index.vue';
import Heading from '@/components/Heading/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import ResultSearch from '@/components/ResultSearch/index.vue';
import Checkbox from '@/components/Checkbox/index.vue';
import Modal from '@/components/ModalAddUser/index.vue';
import Button from '@/components/Button/index.vue';
import CustomTable from '@/components/Table/index.vue';
import Tabs from '@/components/NavTabs/index.vue';
import Tab from '@/components/NavTab/index.vue';
import getTerritoryByAgentDocumentService, {
  TerritoryStatus,
} from '@/services/territory/get-territory-by-agent-document';
import NotificationCenter from '@/components/NotificationCenter/index.vue';
import { formatStringOnlyNumbers, getUserGroup } from '@/utils';
import getTerritoriesByFrigId from '@/services/territory/get-territories-by-frig-id';
import { setReadNotification, SetReadNotificationParams } from '@/services/notifications/set-read-notification';
import term from '@/../Term.json';
import ModalDefault from '@/components/Modal/index.vue';
import Card from '@/components/Card/index.vue';
import { getNotificationRead, getNotificationUnread, GetNotificationParams } from '@/services/notifications/get-notification';
import {
  AccessDetails, HeadDetails, Label, Requested,
} from '@/components/ResultSearch/styles';
import CountLabel, { TextP } from './styles';

export default Vue.extend({
  components: {
    CountLabel,
    CustomTable,
    Footer,
    Header,
    Heading,
    ResultMessage,
    ResultSearch,
    NotificationCenter,
    TextP,
    Modal,
    Checkbox,
    Button,
    Tab,
    Tabs,
    AccessDetails,
    Card,
    HeadDetails,
    Label,
    Requested,
    ModalDefault,
  },
  data() {
    return {
      loaded: false,
      inputSearch: '',
      isHome: true,
      territories: [],
      results: [{}],
      modalAddAgent: false,
      modalAddAgent2: false,
      openNotificationCenter: false,
      userGroup: '',
      termChange: false,
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      Termo: term.Term,
      notifications: [] as any[],
      loadingNotificationCenterNotViewed: false,
      loadingNotificationCenterViewed: false,
      notificationEntity: {} as any,
      notificationCount: 0,
    };
  },
  computed: mapGetters([
    'getNotificationsUnread',
    'getNotificationsRead']),
  methods: {
    ...mapMutations(['setNotificationUnread', 'setNotificationRead']),
    ...mapActions({
      insertDateStatus: 'insertDateStatus',
      getStatusbycdUser: 'getStatusbycdUser',
    }),
    async getTerritories() {
      this.userGroup = `${getUserGroup()}`;
      const { idUser } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');

      this.territories = await getTerritoriesByFrigId(idUser);

      this.loaded = true;
    },
    async search(value: string) {
      const formattedValue = formatStringOnlyNumbers(value);
      this.results = await getTerritoryByAgentDocumentService(formattedValue,
        '',
        TerritoryStatus.provisional, true);
      this.inputSearch = value;
      this.isHome = false;
      this.openNotificationCenter = false;
    },
    cleanSearch() {
      this.isHome = true;
      this.openNotificationCenter = false;
    },
    changeTerm() {
      this.termChange = !this.termChange;
    },
    handleOpenNotificationCenter() {
      this.openNotificationCenter = !this.openNotificationCenter;
    },
    onSetReadNotification(notification: any) {
      this.notificationEntity = {};
      if (!notification.viewed) {
        this.notificationEntity = this.$store.state.notificationsUnread.find((n: any) => n.id === notification.id);
        this.notificationCount -= 1;
      }
      if (notification.viewed) {
        this.notificationEntity = this.$store.state.notificationsRead.find((n: any) => n.id === notification.id);
      }
      const result = this.notifications.map((n: any) => {
        if (n.id === this.notificationEntity.id) {
          const params: SetReadNotificationParams = {
            notificationId: this.notificationEntity.id,
            userId: this.notificationEntity.userId,
            tokenKey: this.userLoged.company.stKey,
          };
          setReadNotification(params);
          return { ...n, read: true, viewed: true };
        }
        return n;
      });
      this.notifications = result;
    },
    async onWatch() {
      this.loadingNotificationCenterNotViewed = true;
      this.$watch(
        // @ts-ignore
        (vm) => [vm.getNotificationsUnread, vm.getAppointmentNotification],
        (value) => {
          const [notificationsUnread] = value;
          notificationsUnread.forEach((n) => {
            const notification = this.notifications.find((not: any) => not.id === n.id && not.viewed === false);
            if (!notification) { this.notifications.push(n); }
          });
          this.loadingNotificationCenterNotViewed = false;
          this.notificationCount = this.$store.state.notificationsUnread.length;
        },
      );
    },
    async getNotificationReadMonitoring() {
      this.loadingNotificationCenterViewed = true;
      const params: GetNotificationParams = {
        userId: this.$store.state.userLogged.idUser,
        tokenKey: this.$store.state.userLogged.company.stKey,
        typeUser: 'FRIG',
      };

      await getNotificationRead(params).then((data) => {
        this.setNotificationRead(Array.isArray(data) ? data : []);
      });
      const notificationsRead = this.getNotificationsRead;
      if (notificationsRead.length > 0) {
        /* eslint-disable no-param-reassign */
        notificationsRead.forEach((n: any) => {
          console.log('n', n);
          if (n.type === 'question') {
            n.type = 'info';
          }
          this.notifications.push(n);
        });
      }
      /* eslint-enable no-param-reassign */
      this.loadingNotificationCenterViewed = false;
    },
    async reloadNotificationUnread() {
      this.loadingNotificationCenterNotViewed = true;
      const params: GetNotificationParams = {
        userId: this.$store.state.userLogged.idUser,
        tokenKey: this.$store.state.userLogged.company.stKey,
        typeUser: 'FRIG',
      };

      await getNotificationUnread(params).then((data) => {
        this.setNotificationUnread(Array.isArray(data) ? data : []);
      });
      const notificationsUnread = this.getNotificationsUnread;
      if (notificationsUnread.length > 0) {
        notificationsUnread.forEach((n) => {
          const newNotification = this.$store.state.notificationsUnread.filter((not) => not.id === n.id);
          if (!newNotification) {
            this.notifications.push(n);
          }
        });
      }
      this.loadingNotificationCenterNotViewed = false;
    },
    async Acept() {
      const termAccepted = {
        cdUser: this.userLoged.idUser.toString(),
        tokenKey: this.userLoged.company.stKey,
        status: 'Aceite',
      };
      if (this.termChange === true) {
        this.insertDateStatus(termAccepted);
        this.modalAddAgent = false;
      }
    },
    async readNotification(value: number) {
      const { notifications } = this.$store.state;
      const resultNotifications = notifications.map(async (notification: any) => {
        if (notification.id === value) {
          // @ts-ignore
          await this.setAsRead({ userType: 'Frigorifico', territoryAccessIds: [value] });
          return { ...notification, read: true };
        }
        return notification;
      });

      const result = await Promise.all(resultNotifications);
      // @ts-ignore
      this.setNotification(result);
    },

  },
  async mounted() {
    this.onWatch();
    this.getNotificationReadMonitoring();
    this.getTerritories();
    const termStatus = {
      cdUser: this.userLoged.idUser,
      tokenKey: this.userLoged.company.stKey.toString(),
    };
    await this.getStatusbycdUser(termStatus);
    this.modalAddAgent = !this.$store.state.statusGet.status;
  },
});
